import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";
import WithAjax from "../common/helpers/WithAjax";
import TabList from "../common/helpers/TabList";
import { setJumbotronTitle } from "../../actions/common";
import { clearVacancy, fetchVacancyOverviewSuccess } from "../../actions/pages/vacancy-page";
import VacancyOverview from "./VacancyOverview";
import Criteria from "./Criteria";
import Candidates from "./Candidates";
import Contracts from "./Contracts";
import History from "./History";
import VacancyAdminMessagesTab from "./VacancyAdminMessagesTab";
import { checkPermission } from "../common/functions/permissions";
import { PERMISSION_ADMINMESSAGES_READ } from "../../constants";

const mapStateToProps = (state, ownProps) => ({
  overview: state.vacancyPage.overview,
  isLoading: state.common.isLoading,
});
const mapDispatchToProps = (dispatch) => ({
  setJumbotronTitle: (title) => dispatch(setJumbotronTitle(title)),
  clearVacancy() {
    dispatch(clearVacancy());
  },
  fetchVacancyOverviewSuccess(overview) {
    dispatch(fetchVacancyOverviewSuccess(overview));
  },
});

const VacancyEdit = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  lifecycle({
    componentDidMount() {
      let id = parseInt(this.props.match.params.id, 10);

      if (!Number.isInteger(id)) {
        return;
      }

      const contentItems = [
        {
          label: "Overview",
          link: "overview",
          content: <VacancyOverview vacancyId={id} />,
        },
        {
          label: "Criteria",
          link: "criteria",
          content: <Criteria vacancyId={id} />,
        },
        {
          label: "Candidates",
          link: "candidates",
          content: <Candidates vacancyId={id} />,
        },
        {
          label: "Contracts",
          link: "contracts",
          content: <Contracts vacancyId={id} />,
        },
        {
          label: "History",
          link: "history",
          content: <History vacancyId={id} />,
        },
      ];

      if (checkPermission(PERMISSION_ADMINMESSAGES_READ)) {
        contentItems.push({
          label: "Messages",
          link: "admin-messages",
          content: <VacancyAdminMessagesTab vacancyId={id} />,
        });
      }

      this.setState({ contentItems: contentItems });

      this.fetchVacancy();
    },
    componentDidUpdate(prevProps) {
      if (this.props.overview === null && !this.props.isLoading) {
        this.fetchVacancy();
      }
    },
    fetchVacancy() {
      let id = parseInt(this.props.match.params.id, 10);

      let url = "vacancies/" + id;

      this.props.clearVacancy();
      this.props.ajax.get(url, true, (data) => {
        let jumbotronContent = [
          { label: data.ProductionTitle, url: "/productions/" + data.ProductionId + "/overview" },
          { label: "Team", url: "/productions/" + data.ProductionId + "/creativeTeam" },
          { label: data.SkillTypeLabel },
        ];
        this.props.setJumbotronTitle(jumbotronContent);

        this.props.fetchVacancyOverviewSuccess(data);
      });
    },
  })
);

export default WithAjax(VacancyEdit(TabList));
